export const Field = ({ label, name, type = "text", required, as, options = [], value, onChange, placeholder, testid }) => {
  const base = "w-full rounded-2xl bg-cream border border-terra/20 px-4 py-3.5 text-ink placeholder:text-muted-ink/70 outline-none transition-[border-color,box-shadow] duration-300 focus:border-pink focus:ring-4 focus:ring-pink/25";
  const props = { id: name, name, required, value, onChange, placeholder, "data-testid": testid, className: base };
  return (
    <label htmlFor={name} className="block">
      <span className="block text-xs font-semibold tracking-[0.15em] uppercase text-muted-ink mb-2">{label}{required && <span className="text-terra-deep"> *</span>}</span>
      {as === "textarea" ? (
        <textarea rows={4} {...props} />
      ) : as === "select" ? (
        <select {...props}>
          <option value="">Select…</option>
          {options.map((o) => <option key={o} value={o}>{o}</option>)}
        </select>
      ) : (
        <input type={type} {...props} />
      )}
    </label>
  );
};
